module.exports = __webpack_public_path__ + "static/media/google_15.426ae620.svg";